import axios from 'App/axios';
import { ReportStatus } from 'commons/types';

export type CreateWithdrawalReportResponse = {
  requestId: number;
};

export type WithdrawalReportStatusDataType = {
  status: ReportStatus;
  temporaryDownloadUrl?: string;
};

const createWithdrawalReport = async (
  withdrawalId: number,
): Promise<CreateWithdrawalReportResponse> => {
  const response = await axios.post<CreateWithdrawalReportResponse>(
    '/admin/withdrawals-report',
    { withdrawalId },
  );
  return response.data;
};

const createWithdrawalPdfReport = async (
  withdrawalId: number,
): Promise<CreateWithdrawalReportResponse> => {
  const response = await axios.post<CreateWithdrawalReportResponse>(
    '/admin/withdrawal-pdf-report',
    { withdrawalId },
  );
  return response.data;
};

const getWithdrawalReportStatus = async (
  requestId: number,
): Promise<WithdrawalReportStatusDataType> => {
  const response = await axios.get<WithdrawalReportStatusDataType>(
    `/admin/withdrawals-report/${requestId}`,
  );
  return response.data;
};

const withdrawalReportService = {
  createWithdrawalReport,
  createWithdrawalPdfReport,
  getWithdrawalReportStatus,
};

export default withdrawalReportService;
